export const LIVIA_LS_KEY = '@Livia'
export const KEEP_LOGGED_LS_KEY = '@Livia/KEEP_LOGGED'
export const SESSION_EXPIRED_KEY = '@NSW/sessao-expirada'
export const REDIRECT_TO = '@redirectToUrl'
export const CAMPAIGNS = '@LiviaAuth:Campaigns'
export const TIME_FOR_ENABLE_RESEND_TOKEN = 90
